import { Text } from "@radix-ui/themes";
import { memo } from "react";
import { HoverDetailsButton } from "./hover-details-button";
import { BaseCellProps } from "../lib/types";

const AnomalyReportCellComponent = ({
  value,
  onDetailsClick,
}: BaseCellProps) => {
  return (
    <>
      <Text size="1" color="gray" className="line-clamp-3 min-w-32 max-w-48">
        {value || "-"}
      </Text>
      <HoverDetailsButton onClick={onDetailsClick} />
    </>
  );
};

export const AnomalyReportCell = memo(AnomalyReportCellComponent);
